import React from "react";

import Grid from "@material-ui/core/Grid";
import withStyles from "@material-ui/core/styles/withStyles";
import FormHelperText from "@material-ui/core/FormHelperText";

import {isRequiredQuestion} from "../../../../../../utils";
import RichTextEditor from "../../../formElement/RichTextEditor";
import CheckboxListCardsQuestion from "../../../question/ChecboxListCardsQuestion";
import InfoCard from "../../DynamicStep/components/InfoCard";

import styles from "./styles";

const AssetsOriginStep = props => {
  const {
    classes,
    onAnswerChange,
    questions: [
      origin_of_assets,
      notes_for_origin_of_assets
    ],
    dataService,
  } = props;

  const visibilityStyles = {
    // FIXME: step should not be show at all
    visibility: dataService.isSwitchSellFlow ? 'hidden' : 'visible'
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12} style={visibilityStyles}>
        Nachstehende Angaben dienen der Vermeidung von Geldwäsche. Sollte der Anlagebetrag aus mehreren Quellen stammen
        (z.B. aus einer Erbschaft und aus Berufseinkünften), sind diese vollständig zu erfassen.
      </Grid>

      <Grid item xs={12} style={visibilityStyles}>
        {origin_of_assets.error && (
          <FormHelperText error={true}>{origin_of_assets.error}</FormHelperText>
        )}
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <CheckboxListCardsQuestion question={origin_of_assets} onAnswerChange={onAnswerChange} />
          </Grid>
        </Grid>
      </Grid>

      {!!origin_of_assets.question_info && (
        <Grid item xs={12}>
          <InfoCard uid={`${origin_of_assets.uid}-info`} isNewDesign info_text={origin_of_assets.question_info} />
        </Grid>
      )}

      <Grid item xs={12} style={visibilityStyles}>
        <Grid container spacing={2}>
          <Grid item xs={12} className={classes.subHeader}>{notes_for_origin_of_assets.question_text}</Grid>
          <Grid item xs={12}>{notes_for_origin_of_assets.question_info}</Grid>
          <Grid item xs={12}>
            <RichTextEditor
              uid={notes_for_origin_of_assets.uid}
              value={notes_for_origin_of_assets.answer || ''}
              onChange={(value) => onAnswerChange(notes_for_origin_of_assets.uid, value)}
              rows={6}
              required={isRequiredQuestion(notes_for_origin_of_assets)}
              error={notes_for_origin_of_assets.error}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
};

export default withStyles(styles)(AssetsOriginStep);